import { ModifierProperty } from '@/enums';
import { useGetComponentConfigByModule } from '@/hooks';
import { ExpandTabsPaneProps } from '@/types';
import { CustomTabs } from '@amili-v3/amili-v3-design';
import React, { memo, useMemo } from 'react';

const TabsConfig: React.FC<ExpandTabsPaneProps> = props => {
  const { items: originItems, isShowTab, ...rest } = props;

  const tabConfig = useGetComponentConfigByModule('tab');

  const items = useMemo(
    () =>
      originItems.reduce(
        (accumulator, tabItem) => {
          const customKey = `${tabItem.id.toLowerCase()}-tab-item`;
          const hidden =
            tabConfig[customKey]?.modifier === ModifierProperty.HIDDEN;

          if (hidden) return accumulator;

          accumulator.push({
            ...tabItem,
            label: (
              <span data-customization-key={customKey}>{tabItem.label}</span>
            ),
          });
          return accumulator;
        },
        [] as ExpandTabsPaneProps['items'],
      ),
    [originItems, tabConfig],
  );
  const isShowTabDefault =
    items?.filter(tab => tab.id !== 'all-channels-kit')?.length > 1;

  return (
    <CustomTabs
      {...rest}
      items={items}
      isShowTab={isShowTab ?? isShowTabDefault}
    />
  );
};

export default memo(TabsConfig);
